module.exports = __webpack_public_path__ + "764938c65acba802b78cb4a17f030ee9.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Recipes/Assets/smoothie2.png
// module id = 1348
// module chunks = 0